import { observable } from "mobx";
import { Type } from "class-transformer";
import type { IBankExport } from "./bankExport";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class InternalTransferExportResponse implements IBankExport {
  id!: string;

  @observable
  name!: string;

  @observable
  @Type(() => Date)
  createdAt!: Date;

  @observable
  @Type(() => Date)
  lastDownloadedAt?: Date;

  @observable
  lastDownloadedBy?: string;
}
